import React from 'react';
import SubmitButton from '@/components/Checkout/components/SubmitButton';
import { useForm } from 'react-hook-form';
import { checkValidEmail } from '@/lib/muzology';
import PlatinumRecord from '@/assets/platinum-record.png';
import SymbolsBackground from '@/assets/backgrounds/math-symbols.png';
import SymbolsRecordMedium from '@/assets/backgrounds/SymbolsRecordMedium.png';
import SymbolsRecordMobile from '@/assets/backgrounds/SymbolsRecordMobile.png';
import Image from 'next/legacy/image';
import axios from 'axios';
import { ParentEmailSignup, ParentEmailSignupSuccessful } from '../../../analytics/events';
import { useAnalytics } from '@/analytics/AnalyticsProvider';
import cx from 'classnames';
import BalanceText from '@/components/BalanceText/BalanceText';

const CheckoutChild2 = ({ isLoading, setLoading, nextStage, token }) => {
    const analytics = useAnalytics();
    const {
        trigger,
        register,
        handleSubmit,
        watch,
        formState: { errors }
    } = useForm();

    const watchPurpose = watch('email_user', '');

    const onSubmit = async (data) => {
        setLoading(true);
        /* eslint-disable camelcase */
        const payload = {
            source: 'student',
            email: data.email,
            type: data.email_user,
            location: window.location.href,
            anonymous_id: analytics.getAnonymousId(),
            checkout_token: token,
        };
        /* eslint-enable camelcase */

        await analytics.track(ParentEmailSignup, data);

        axios
            .post('/api/email_signup/', payload)
            .then(async () => {
                await analytics.track(ParentEmailSignupSuccessful, data);
                setLoading(false);
                nextStage({ stage: 3 });
            })
            .catch((err) => {
                setLoading(false);
                console.log('submit parent email error:', err);
            });
    };

    return (
        <div className='font-Poppins mt-6 sm:mt-12 min-h-[900px] sm:min-h-[100%] bg-none pt-5 sm:pt-0'>
            <div className='max-w-[1000px] mx-auto text-left sm:pl-5 lg:pl-0'>
                <div className=' hidden sm:block text-[44px] font-semibold'>Okay Great!</div>
                <div className='hidden text-[#4E4E4E] text-lg sm:text-xl font-bold sm:font-light text-center sm:text-left max-w-[3600px] sm:max-w-full mx-auto sm:mx-0 px-4 sm:px-0 mt-1 sm:mt-3'>
                    <BalanceText>A parent or teacher needs to set up your account. We'll email them now!</BalanceText>
                </div>
            </div>

            <div className='w-full  flex flex-col lg:flex-row items-center lg:items-stretch sm:gap-6 lg:gap-0 mt-10'>
                <div className='w-full lg:w-[44%] relative'>
                    <div className=' hidden lg:block absolute top-[20%] left-1/4  z-20'>
                        <Image src={PlatinumRecord} className='rotate-animation h-auto sm:h-full sm:max-h-[100%] w-full max-w-none  sm:max-w-[100%]' />
                    </div>
                    <div className='hidden lg:block  absolute top-[7%] left-[3.5%] z-10 '>
                        <Image src={SymbolsBackground} className='h-auto sm:h-full sm:max-h-[100%] w-full max-w-none  sm:max-w-[100%]' />
                    </div>
                </div>
                <div className='w-full lg:w-[56%] relative'>
                    <div className='shadow-checkout bg-white rounded-2xl sm:rounded-lg w-full pb-16 pt-7 sm:pt-10 max-w-[355px] sm:max-w-[500px] md:max-w-[600px] mx-auto px-5 md:px-0 '>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className='mb-4 block text-center max-w-[380px] text-base sm:text-xl font-semibold text-[#303030] mx-auto'>
                                <BalanceText>A parent or teacher needs to set up your account. We'll email them now!</BalanceText>
                            </div>
                            <div className='max-w-[480px] mx-auto sm:mt-10'>
                                <label className='block text-sm sm:text-lg font-normal text-[#303030] text-left sm:text-center'>
                                    Enter email for your parent or teacher:
                                </label>
                                <input
                                    type='input'
                                    {...register('email', { required: true, validate: { validEmail: checkValidEmail } })}
                                    style={{ boxShadow: '0px 1px 1px 0px rgba(0, 0, 0, 0.04), 0px 2px 5px 0px rgba(0, 0, 0, 0.08)' }}
                                    className='block w-full px-4 py-4 mt-3.5 text-[#6B7280] bg-white border-[#e4e6e9] border-[1.5px] border-solid rounded-md focus:border-[#5EC5DF] focus:ring-[#5EC5DF] focus:outline-none focus:ring focus:ring-opacity-40'
                                />
                                {errors.email && (
                                    <div className='text-red-500 mt-2 text-sm md:text-[17px] text-left max-w-[480px] mx-auto'>Please enter valid email</div>
                                )}
                            </div>
                            <div className='mt-5'>
                                <div className='text-left sm:text-center max-w-[310px]  mr-auto text-[15px] sm:text-lg font-normal text-[#303030]'>
                                    This is the email for...
                                </div>
                                <div className='flex items-center justify-between max-w-[480px] mx-auto mt-2.5'>
                                    <label
                                        className={cx(
                                            'email-type w-full max-w-[100px] sm:max-w-[150px] h-[63px] rounded-lg bg-[#F4FBFF] text-[#6E7191] p-2 text-sm sm:text-base flex items-center justify-center font-normal font-Poppins text-center cursor-pointer sm:hover:scale-110 transform transition-all duration-300 ease-in-out',
                                            { '!bg-[#6F5FE6] !text-white': watchPurpose === 'parent' }
                                        )}
                                    >
                                        <div className='title'>
                                            My parent/ <br /> guardian
                                        </div>
                                        <input type='radio' name='email_user' {...register('email_user', { required: true })} value='parent' />
                                    </label>
                                    <label
                                        className={cx(
                                            'email-type w-full  max-w-[100px] sm:max-w-[150px] h-[63px] rounded-lg bg-[#F4FBFF] text-[#6E7191] p-2 text-sm sm:text-base flex items-center justify-center font-normal font-Poppins text-center cursor-pointer sm:hover:scale-110 transform transition-all duration-300 ease-in-out',
                                            { '!bg-[#6F5FE6] !text-white': watchPurpose === 'teacher' }
                                        )}
                                    >
                                        <div className='title'>My teacher</div>
                                        <input type='radio' name='email_user' {...register('email_user', { required: true })} value='teacher' />
                                    </label>
                                    <label
                                        className={cx(
                                            'email-type w-full max-w-[90px] sm:max-w-[150px] h-[63px] rounded-lg bg-[#F4FBFF] text-[#6E7191] p-2 text-sm sm:text-base flex items-center justify-center font-normal font-Poppins text-center cursor-pointer sm:hover:scale-110 transform transition-all duration-300 ease-in-out',
                                            { '!bg-[#6F5FE6] !text-white': watchPurpose === 'other' }
                                        )}
                                    >
                                        <div className='title'>Other</div>
                                        <input type='radio' name='email_user' {...register('email_user', { required: true })} value='other' />
                                    </label>
                                </div>
                                {errors.email_user && (
                                    <div className='text-red-500 mt-2 text-sm md:text-[17px] text-left max-w-[480px] mx-auto'>This field is required</div>
                                )}
                            </div>
                            <div>
                                <div className='flex items-center justify-center mt-7'>
                                    <SubmitButton
                                        id='submit-parent-email'
                                        onClick={() => trigger()}
                                        // isLoading={isLoading}
                                        text='Get Started'
                                        className='h-11 sm:h-[58px]'
                                    />
                                </div>
                            </div>

                            <div className='hidden text-center max-w-[380px] text-[15px] sm:text-xl font-semibold text-[#303030] mx-auto mt-4'>
                                We’ll Send Them an Email Right Now to Get you Started!
                            </div>
                        </form>
                    </div>
                </div>
            </div>
            <style jsx>{`
                .rotate-animation {
                    -webkit-animation: spin 10s linear infinite;
                    -moz-animation: spin 10s linear infinite;
                    animation: spin 10s linear infinite;
                    @-moz-keyframes spin {
                        100% {
                            -moz-transform: rotate(360deg);
                        }
                    }
                    @-webkit-keyframes spin {
                        100% {
                            -webkit-transform: rotate(360deg);
                        }
                    }
                    @keyframes spin {
                        100% {
                            -webkit-transform: rotate(360deg);
                            transform: rotate(360deg);
                        }
                    }
                }

                .email-type {
                    input {
                        position: absolute;
                        opacity: 0;
                        cursor: pointer;
                        height: 0;
                        width: 0;
                    }
                }
            `}</style>
        </div>
    );
};

export default CheckoutChild2;
